import { render, staticRenderFns } from "./UserSettingReportXinZhu.vue?vue&type=template&id=7a4abf56&scoped=true&"
import script from "./UserSettingReportXinZhu.vue?vue&type=script&lang=js&"
export * from "./UserSettingReportXinZhu.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingReportXinZhu.vue?vue&type=style&index=0&id=7a4abf56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4abf56",
  null
  
)

export default component.exports